/**
 * Returns a boolean indicating whether given `value` is a primitive.
 * @param {any} value
 * @return {boolean}
 */
function isPrimitive(value) {
    if (value === null) {
        return true;
    }

    return !["function", "object"].includes(typeof value);
}

/**
 * @property {Array} allowedValues
 * @property {any} value
 */
export default class Switch {
    /**
     * @param {Array} allowed_values
     * @param {any} initial_value
     */
    constructor(allowed_values, initial_value) {
        if (!Array.isArray(allowed_values)) {
            throw new TypeError(`Switch constructor expects parameter 1 to be an array, ${typeof allowed_values} given`);
        }

        if (allowed_values.find((candidate) => {
            return !isPrimitive(candidate);
        }) !== undefined) {
            throw new Error(`Switch constructor expects parameter 1 to be an array of primitive values only`);
        }

        this.allowedValues = allowed_values;

        if (!isPrimitive(initial_value)) {
            throw new Error(`Switch constructor expects parameter 2 to be a primitive`);
        }

        if (!this.allowedValues.includes(initial_value)) {
            throw new TypeError(`Switch constructor expects parameter 2 to be included in values of parameter 1`);
        }

        this.value = initial_value;
    }

    /**
     * Sets given `value` as this switch value.
     * @param {any} value
     * @return {Switch}
     */
    setValue(value) {
        if (!isPrimitive(value)) {
            throw new Error(`Switch.setValue() method expects parameter 1 to be a primitive`);
        }


        if (!this.allowedValues.includes(value)) {
            throw new Error(`Switch.setValue() method expects parameter 1 to be one of Switch.allowedValues property values`);
        }

        this.value = value;
        return this;
    }

    valueOf() {
        return this.value;
    }
}
